export { default } from './Camera';
